import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** User email only form */
export interface UserEmailInterface {
  email: string;
}

export const UserEmailDto = SerdeDtoClass.create<UserEmailInterface>(SecurityDtoKeysEnum.USER_EMAIL_DTO, {
  email: {
    sortable: true,
    label: 'Email',
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
})
